/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'underscore',
	'prop-types',
	'./Button'
], function(React, _, PropTypes, Button) {

	class ToggleButtonReact extends Button {

		constructor(props){
			super(props);
		}

		_handleClick() {
			this.itemSpec.checked = !this.itemSpec.checked;
			if (this.itemSpec.checked && typeof this.itemSpec.action === 'function') {
				this.itemSpec.action.apply(this, arguments);
			} else if (!this.itemSpec.checked && typeof this.itemSpec.offAction === 'function') {
				this.itemSpec.offAction.apply(this, arguments);
			}
			this.props.updateButton();
		}

		_getButtonClass() {
			const classList = [];
			if(this.itemSpec.checked) {
				classList.push('toolbarButtonToggle selected');
			}
			if(this.itemSpec.className) {
				classList.push(this.itemSpec.className);
			}
			return classList.join(' ');
		}
	}

	ToggleButtonReact.propTypes = {
		itemSpec: PropTypes.array,
		icon: PropTypes.object,
		updateButton: PropTypes.function,
		nextViewCb: PropTypes.function,
		toolbarOptions: PropTypes.object
	};

	return ToggleButtonReact;
});
